// extracted by mini-css-extract-plugin
export var about = "footer-module--about--tqHdn";
export var h4 = "footer-module--h4--oOySb";
export var p = "footer-module--p--ku-sd";